const env = import.meta.env;

// * NODE_ENV does not exist on Vite, instead Vite sets a MODE variable to development when serving and production when building by default
// * Custom modes can also be set using --mode (more info here https://vitejs.dev/guide/env-and-mode.html#modes)
const {
  REACT_APP_ALLOWED_ORIGINS,
  REACT_APP_CONVERSED_SERVER_URL,
  REACT_APP_ENVIRONMENT,
  MODE: NODE_ENV,
} = env;

export { NODE_ENV, REACT_APP_ALLOWED_ORIGINS, REACT_APP_CONVERSED_SERVER_URL };

export const APP_ENVIRONMENT = REACT_APP_ENVIRONMENT;
